import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import SendReceiveButton from '../../../../components/SendReceiveButton/SendReceiveButton';
import Tabs from '../../../../components/Tabs/Tabs';
import AppConfig from '../../../../config';
import useBackButton from '../../../../hooks/useBackButton';
import { t } from '../../../../lang';
import RequestService from '../../../../services/RequestService';
import TypesService from '../../../../services/TypesService';
import WebSocketService from '../../../../services/WebSocketService';
import { appSlice, receiveSlice, sendSlice } from '../../../../store/slices';
import PortfolioAssets from '../PortfolioAssets';
import PortfolioCard from '../PortfolioCard';
import PortfolioHistory from '../PortfolioHistory/PortfolioHistory';

import './PortfolioTemplate.scss';

const { routes } = AppConfig;

const PortfolioTemplate = ({ portfolioId, bodyTranslate }) => {
	const dispatch = useDispatch();
	const availableCurrencies = useSelector(state => state?.app?.availableCurrencies);
	const [balanceAmount, setBalanceAmount] = useState(0);

	const navigate = useNavigate();
	const location = useLocation();

	const GetAvailableCurrencies = useCallback(async () => {
		const res = await RequestService.GetAvailableCurrencies();
		const availableCurrencies_ = res?.Currencies?.filter(currency =>
			TypesService?.AvailableCurrencies?.includes(currency?.CurrencyId)
		);
		dispatch(appSlice.actions.setAvailableCurrencies(availableCurrencies_));
	}, [dispatch]);

	useEffect(() => {
		if (availableCurrencies?.length > 0)
			setBalanceAmount(availableCurrencies.reduce((acc, current) => acc + current.AmountUsd, 0));
	}, [availableCurrencies]);

	useEffect(() => {
		GetAvailableCurrencies();

		const refreshAvailableCurrencies = data => {
			if (data?.type === 'MobileTransactionUpdatedMsg' && data?.msg?.transactionStatus === 2) {
				GetAvailableCurrencies();
			}
		};
		WebSocketService.AddCustomHandler(refreshAvailableCurrencies);
		return () => {
			WebSocketService.RemoveCustomeHandler('refreshAvailableCurrencies');
		};
	}, [GetAvailableCurrencies]);

	useBackButton(false);

	const goToSend = () => {
		dispatch(sendSlice.actions.setSendData());
		navigate(routes.sendAsset, {
			state: { sendStartRouteParams: { search: location.search, hash: location.hash } },
		});
	};

	const goToReceive = () => {
		dispatch(receiveSlice.actions.setReceiveData());
		navigate(routes.receiveAsset);
	};

	return (
		<div className='PortfolioTemplate'>
			<PortfolioCard namePorfolio={t('Crypto portfolio')} balance={balanceAmount} />

			<div className='PortfolioTemplate__body' style={{ transform: `translateX(${bodyTranslate}%)` }}>
				<div className='send-receive'>
					<SendReceiveButton type='Send' onClick={goToSend} />
					<SendReceiveButton type='Receive' onClick={goToReceive} />
				</div>

				<Tabs
					items={[
						{
							name: t('Assets'),
							component: <PortfolioAssets portfolioId={portfolioId} />,
						},
						{
							name: t('History'),
							component: <PortfolioHistory />,
						},
					]}
				/>
			</div>
		</div>
	);
};

PortfolioTemplate.propTypes = {
	portfolioId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	bodyTranslate: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default PortfolioTemplate;
